// @mui
import { alpha, styled } from "@mui/material/styles";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from "@mui/material/ListItemButton";

// ----------------------------------------------------------------------

export const StyledItem = styled(ListItemButton, {
  shouldForwardProp: prop => prop !== "active",
})(({ active, open, depth, config, theme }) => {
  const subItem = depth !== 1;

  // `contrast`: el nav vive sobre la superficie oscura de marca (sidebar).
  const contrast = !!config.contrast;

  const activeStyles = {
    root: {
      color:
        theme.palette.mode === "light" ? theme.palette.primary.main : theme.palette.primary.light,
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "&:hover": {
        backgroundColor: alpha(theme.palette.primary.main, 0.16),
      },
    },
    sub: {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.action.selected,
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  };

  // Branding 2026: item activo como pastilla púrpura sólida sobre el negro.
  const contrastStyles = {
    base: {
      color: alpha(theme.palette.common.white, 0.72),
      "&:hover": {
        color: theme.palette.common.white,
        backgroundColor: alpha(theme.palette.common.white, 0.08),
      },
    },
    root: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark,
      },
    },
    sub: {
      color: theme.palette.common.white,
      backgroundColor: alpha(theme.palette.primary.main, 0.24),
      "&:hover": {
        backgroundColor: alpha(theme.palette.primary.main, 0.32),
      },
    },
    open: {
      color: theme.palette.common.white,
      backgroundColor: alpha(theme.palette.common.white, 0.08),
    },
  };

  const styles = contrast ? contrastStyles : activeStyles;

  return {
    // Root item
    flexDirection: "column",
    justifyContent: "center",
    borderRadius: config.itemRadius,
    minHeight: config.itemRootHeight,
    color: theme.palette.text.secondary,
    margin: `0 ${config.itemGap}px ${config.itemGap}px ${config.itemGap}px`,
    ...(config.hiddenLabel &&
      !subItem && {
        padding: config.itemPadding,
      }),

    ...(contrast && contrastStyles.base),

    // Active root item
    ...(active && {
      ...styles.root,
    }),

    // Sub item
    ...(subItem && {
      margin: 0,
      flexDirection: "row",
      padding: theme.spacing(0, 1),
      minHeight: config.itemSubHeight,
      // Active sub item
      ...(active && {
        ...styles.sub,
      }),
    }),

    // Open
    ...(open &&
      !active && {
        ...(contrast
          ? contrastStyles.open
          : {
              color: theme.palette.text.primary,
              backgroundColor: theme.palette.action.hover,
            }),
      }),
  };
});

// ----------------------------------------------------------------------

export const StyledIcon = styled(ListItemIcon)(({ size }) => ({
  width: size,
  height: size,
  marginRight: 0,
}));
